import { CarrierAutocomplete, DateTimeField, PortAutocomplete, TextField } from 'form';
import { useTranslation } from 'i18n';
import { SectionContainer } from 'ui';

export const ShipmentCreateFieldsSection = () => {
  const { t } = useTranslation('orders');

  return (
    <>
      <SectionContainer title={t('shipmentFields.sections.general')}>
        <TextField label={t('shipmentFields.labels.billOfLadingNumber')} name="bill_of_lading_number" />
        <CarrierAutocomplete name="carrier_1_id" label={t('shipmentFields.labels.carrier1')} />
        <CarrierAutocomplete name="carrier_2_id" label={t('shipmentFields.labels.carrier2')} />
        <CarrierAutocomplete name="carrier_3_id" label={t('shipmentFields.labels.carrier3')} />
        <TextField label={t('shipmentFields.labels.carrierBookingReference')} name="carrier_booking_reference" />
        <DateTimeField label={t('shipmentFields.labels.docsCutOffTime')} name="docs_cut_off_time" />
        <TextField label={t('shipmentFields.labels.freightForwarderReference')} name="freight_forwarder_reference" />
        <PortAutocomplete name="port_of_loading_id" label={t('shipmentFields.labels.selectPortOfLoading')} />
        <DateTimeField label={t('shipmentFields.labels.scheduledDeliveryTime')} name="scheduled_delivery_time" />
        <DateTimeField label={t('shipmentFields.labels.vgmCutOffTime')} name="vgm_cut_off_time" />
        <TextField
          label={t('shipmentFields.labels.freeTimeAvailableDays')}
          name="free_time_available"
          type="number"
          slotProps={{ htmlInput: { min: 0 } }}
          helperText={t('shipmentFields.helperText.freeTimeAvailable')}
        />
        <TextField
          sx={{ gridColumn: 'span 3' }}
          label={t('shipmentFields.labels.additionalInvoiceDescription')}
          name="additional_invoice_description"
          multiline
          rows={10}
        />
      </SectionContainer>
      <SectionContainer title={t('shipmentFields.sections.tracking')}>
        <DateTimeField
          label={t('shipmentFields.labels.scheduledPortDepartureTime')}
          name="scheduled_port_departure_time"
        />
        <DateTimeField
          label={t('shipmentFields.labels.manualEstimatedPortDepartureTime')}
          name="manual_estimated_port_departure_time"
        />
        <DateTimeField
          label={t('shipmentFields.labels.manualActualPortDepartureTime')}
          name="manual_actual_port_departure_time"
        />
        <DateTimeField label={t('shipmentFields.labels.scheduledPortArrivalTime')} name="scheduled_port_arrival_time" />
        <DateTimeField
          label={t('shipmentFields.labels.manualEstimatedPortArrivalTime')}
          name="manual_estimated_port_arrival_time"
        />
        <DateTimeField
          label={t('shipmentFields.labels.manualActualPortArrivalTime')}
          name="manual_actual_port_arrival_time"
        />
      </SectionContainer>
    </>
  );
};
